import { IS, NO, UIButton, UIColor, YES } from "uicore-ts"
import { LanguageService } from "../LanguageService"
import { CBCheckbox } from "./CB/CBCheckbox"
import { RHCheckbox } from "./RH/RHCheckbox"
import { RHColor } from "./RH/RHColor"
import { RHForms } from "./RH/Utils_slop/RHDesignTokens"


export class SearchableDropdownRow extends UIButton {
    
    _checkbox: CBCheckbox
    
    type = SearchableDropdownRow.type.selectableItem
    showsSelectionControl = NO
    _SearchableDropdownRowWasHoveredFunction?: () => void
    
    constructor(elementID: string) {
        
        super(elementID)
        
        this._checkbox = new RHCheckbox(elementID + "Checkbox")
        this._checkbox.userInteractionEnabled = NO
        this._checkbox.configureWithObject({
            style: { pointerEvents: "none" }
        })
        this._checkbox.checkbox.configureWithObject({
            style: { pointerEvents: "none" }
        })
        this._checkbox.titleLabel.configureWithObject({
            style: { pointerEvents: "none" }
        })
        this.addSubview(this._checkbox)
        
        this.configureWithObject({
            style: { outline: "none" }
        })
        this.titleLabel.configureWithObject({
            style: {
                fontSize: RHForms.dropdownRowFontSize,
                lineHeight: RHForms.dropdownRowLineHeight
            }
        })
        this._checkbox.titleLabel.configureWithObject({
            style: {
                fontSize: RHForms.dropdownRowFontSize,
                lineHeight: RHForms.dropdownRowLineHeight
            }
        })
        
    }
    
    
    set titleText(titleText: string) {
        this.titleLabel.text = titleText
        this._checkbox.titleLabel.text = titleText
    }
    
    get titleText() {
        return this.titleLabel.text
    }
    
    
    override set selected(selected: boolean) {
        super.selected = selected
        this._checkbox.selected = selected
    }
    
    override get selected() {
        return super.selected
    }
    
    
    override set focused(focused: boolean) {
        this._focused = focused
        this.updateContentForCurrentState()
    }
    
    override get focused() {
        return this._focused ?? NO
    }
    
    
    static type = {
        
        "sectionTitle": "SectionTitle",
        "selectedItem": "SelectedItem",
        "selectableItem": "SelectableItem",
        "customItem": "CustomItem"
        
    }
    
    
    override updateContentForNormalState() {
        
        
        if (this.type == SearchableDropdownRow.type.sectionTitle) {
            
            
            this.backgroundColor = UIColor.transparentColor
            this.titleLabel.textColor = RHColor.textSecondary
            
            this.configureWithObject({
                style: {
                    borderTop: `${RHForms.dropdownRowBorderBottomWidth} solid ${RHForms.dropdownRowSectionBorderColor.stringValue}`
                }
            })
            
            this.titleLabel.configureWithObject({
                style: { marginLeft: "" }
            })
            
            this.textSuffix = ""
            
            if (this._checkbox) {
                
                this._checkbox.hidden = YES
                
            }
            
            this.titleLabel.hidden = NO
            
            
        }
        else if (this.type == SearchableDropdownRow.type.selectedItem) {
            
            this.backgroundColor = UIColor.transparentColor
            this.titleLabel.textColor = RHColor.textPrimary
            
            this.configureWithObject({
                style: { borderTop: "" }
            })
            
            //this.titleLabel.style.marginLeft = "20px"
            
            this.textSuffix = ""
            
            if (this._checkbox) {
                
                this._checkbox.hidden = NO
                
                this._checkbox.titleLabel.textColor = RHColor.textPrimary
                
            }
            
            this.titleLabel.hidden = YES
            
            
        }
        else if (this.type == SearchableDropdownRow.type.customItem) {
            
            this.backgroundColor = UIColor.transparentColor
            this.titleLabel.textColor = RHColor.primary
            
            this.configureWithObject({
                style: {
                    borderTop: `${RHForms.dropdownRowBorderBottomWidth} solid ${RHForms.dropdownRowSectionBorderColor.stringValue}`
                }
            })
            
            this.titleLabel.configureWithObject({
                style: { marginLeft: "" }
            })
            
            this.textSuffix = LanguageService.stringForKey(
                "searchableDropdownCustomItem",
                LanguageService.currentLanguageKey,
                "-Custom item"
            )
            
            if (this._checkbox) {
                
                this._checkbox.hidden = YES
                
            }
            
            this.titleLabel.hidden = NO
            
            
        }
        else {
            
            
            this.backgroundColor = UIColor.transparentColor
            this.titleLabel.textColor = RHColor.textPrimary
            
            this.configureWithObject({
                style: { borderTop: "" }
            })
            
            this.titleLabel.configureWithObject({
                style: {
                    marginLeft: RHForms.dropdownRowTitleMarginLeftWithSelectionControl
                }
            })
            
            this.textSuffix = ""
            
            if (this._checkbox) {
                
                this._checkbox.hidden = !this.showsSelectionControl
                this._checkbox.titleLabel.textColor = RHColor.textPrimary
                
            }
            
            this.titleLabel.hidden = this.showsSelectionControl
            
            
        }
        
        this.userInteractionEnabled = YES
        
        
    }
    
    
    get textSuffix() {
        
        return this.titleLabel.textSuffix
        
    }
    
    set textSuffix(textSuffix: string) {
        
        this.titleLabel.textSuffix = textSuffix
        
        this._checkbox.titleLabel.textSuffix = textSuffix
        
    }
    
    
    override updateContentForHoveredState() {
        
        
        this.backgroundColor = RHForms.dropdownRowSelectedHoverBackgroundColor
        
        
    }
    
    
    override updateContentForHighlightedState() {
        
        
        this.backgroundColor = RHColor.rowHover.colorByMultiplyingRGB(0.98)
        
        
    }
    
    override updateContentForFocusedState() {
        
        
        this.backgroundColor = RHColor.rowHover.colorByMultiplyingRGB(0.98)
        
        
    }
    
    
    override updateContentForSelectedState() {
        
        
        this.updateContentForNormalState()
        
        if (this.type == SearchableDropdownRow.type.selectableItem || this.type ==
            SearchableDropdownRow.type.customItem) {
    
            this._checkbox.hidden = NO
            //this._checkbox.titleLabel.hidden = YES;
    
            this._checkbox.titleLabel.textColor = RHColor.textPrimary
    
            if (IS(this._titleLabel)) {
        
                this._titleLabel.hidden = YES
        
            }
    
        }
        
        
    }
    
    
    override wasRemovedFromViewTree() {
        
        super.wasRemovedFromViewTree()
        
        this.highlighted = NO
        this.hovered = NO
        
        
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        
        if (this._checkbox) {
            
            
            this._checkbox.style.top = "25%"
            this._checkbox.style.height = "30px"
            
            
            this._checkbox.style.left = "" + this.contentPadding + "px"
            this._checkbox.style.right = "" + this.contentPadding + "px"
            
            
        }
        
        
    }
    
    
}






























